export default __webpack_public_path__ + "75d7785.png";